module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "contributors"
    }
  }, [_c('h1', {
    staticClass: "h1",
    attrs: {
      "id": "pz6-2_1"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contenttoc#pz6-2"
    }
  }, [_vm._v(" FOREWORD")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("M NOT ON")]), _vm._v(" social media like my friends Isaiah Saldivar and Vladimir Savchuk, but I joke with them by saying Vlad is better looking. Actually, it is a tie. They are both great men of God.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In my book "), _c('i', [_vm._v("When Pigs Move In")]), _vm._v(", I say we should be raising up armies instead of audiences. I believe that is happening today, and Isaiah is one of the leaders. He is right when he says there is an army rising up, a mighty remnant that is casting out demons, laying hands on the sick, and seeing miracles happen. There’s a mighty move of God underway, and in this book, Isaiah shows how you can be part of it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As you begin this journey through the pages of "), _c('i', [_vm._v("How to Cast Out Demons")]), _vm._v(", may you be equipped, empowered, and emboldened to stand firm in the face of spiritual opposition. May you discover afresh the reality of Christ’s victory over the powers of darkness and walk in the freedom and authority that He has secured for you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It is my prayer that this book will serve as a beacon of light in a world shrouded in darkness, guiding believers to greater depths of spiritual understanding, intimacy with God, and victory in spiritual warfare.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICKERMAN")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNDER")]), _vm._v(", D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICKERMAN")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INISTRIES AND")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IBERATED")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IVING")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UTHOR OF")]), _vm._v(" "), _c('i', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEN")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGS")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N")])]), _vm._v("; "), _c('i', [_vm._v("K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEP THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGS")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UT")])]), _vm._v("; "), _c('i', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EOPLE")]), _vm._v(", P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGS, AND")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RINCIPALITIES")])]), _vm._v("; "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" "), _c('i', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROTECTED BY")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGELS")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59c1ebc4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter.vue
// module id = 69
// module chunks = 0